import { Button, Dialog } from '@agro1desenvolvimento/react-components';
import './ModalDecisao.scss';

interface Props {
  title: string;
  description: string;
  okButtonLabel?: string;
  cancelButtonLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  visible?: boolean;
}

export default function ModalDecisao({
  title, description, okButtonLabel, cancelButtonLabel, onConfirm, onCancel, visible,
}: Props) {
  return (
    <Dialog
      className="modal-decisao-dialog"
      contentClassName="modal-decisao"
      visible={visible}
      closeOnEscape
      dismissableMask
      onHide={onCancel}
      showHeader={false}
    >
      <h4 className="modal-decisao__title">{title}</h4>
      <p className="modal-decisao__description">{description}</p>
      <div className="modal-decisao__buttons">
        <Button
          className="modal-decisao__button modal-decisao__button--cancel"
          onClick={onCancel}
        >
          {cancelButtonLabel ?? 'Não'}
        </Button>
        <Button
          className="modal-decisao__button modal-decisao__button--confirm"
          onClick={onConfirm}
        >
          {okButtonLabel ?? 'Sim'}
        </Button>
      </div>
    </Dialog>
  );
}
